
import {permissionList} from "@/api/http";

const columnList: Array<column> = [
    {
        prop: "name",
        label: "师傅名称",
        width: 130,
    },
    {
        prop: "label",
        label: "标签",
        width: 295,
    },
    {
        prop: "experience",
        label: "经验",
        width: 295,
    },
];

import {
    defineComponent,
    ref,
    reactive,
    inject,
    provide,
    onMounted,
    watch,
} from "vue";
import { validateInput, validateClass } from "@/assets/js/formRules";
import { useRoute, useRouter } from "vue-router";
import { formType,column } from "@/assets/types/common";
import { Request } from "@/api/request";
import { ElMessage } from "element-plus";

export default defineComponent({
    name: "Mechanic",
    setup() {
        const setTitle: any = inject("setTitle");
        setTitle(["师傅展示"]);
        let pageSize = ref(10),
            currentPage = ref(1),
            tableData = ref([] as Array<any>),
            total = ref(0),
            roleList = ref({} as any),
            loading = ref(true),
            headClass = inject("headClass"),
            Router = useRouter(),
            setStatus = (id: number): void => {
                if (id) {
                    Request.axiosInstance({
                        url: "adminapi/Employee/upState",
                        data: {
                            id,
                        },
                    }).then((res: any) => {
                        if (res.status == 202) {
                            getTableData();
                        }
                    });
                }
            },
            handleSizeChange = (size: number): void => {
                pageSize.value = size;
                getTableData();
            },
            handleCurrentChange = (page: number): void => {
                currentPage.value = page;
                getTableData();
            },
            getTableData = (): void => {
                loading.value = true;
                let mydata = {
                    type:1,
                    role_name:'mechanic',
                };
                permissionList(mydata).then((res:any)=>{
                    roleList.value = res?.content?.list || 0;
                });
                Request.axiosInstance({
                    url: "adminapi/Employee/list",
                    data: {
                    	pagesize:pageSize.value,
                    	page:currentPage.value
                    },
                }).then((res: any) => {
                    tableData.value = res?.content?.list || [];
                    loading.value = false;
                    total.value = res?.content?.total || 0;
                });
            };

        onMounted(() => {
            getTableData();
        });

        return {
            columnList,
            tableData,
            loading,
            headClass,
            Router,
            setStatus,
            total,
            pageSize,
            currentPage,
			handleSizeChange,
			handleCurrentChange,
            roleList,
        };
    },
});
